import _objectSpread from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { translateObject } from '@huggg/bar-staff';

/**
 * Get the sortOrder direction. Will convert any unsupported sortOrder to 'asc'.
 *
 * @param {String} direction Provided direction from calling method.
 * @returns {String}
 */
function getSortDirection(direction) {
  var validDirections = ['asc', 'desc'];
  return validDirections.indexOf(direction) > -1 ? direction : 'asc';
}

/**
 * Get sortOrder parameter. Will filter out any unsupported sortOrder keys.
 *
 * @param {Array} sortOrder Provided sort order from calling method
 * @returns {Array}
 */
function getSortOrder(sortOrder, sortColumnMap) {
  var sortColumnKeys = Object.keys(sortColumnMap);
  return sortOrder.reduce(function (acc, item) {
    var key = sortColumnKeys.find(function (key) {
      return key === item.field;
    });
    if (key) {
      acc.push({
        field: sortColumnMap[key],
        direction: getSortDirection(item.direction)
      });
    }
    return acc;
  }, []);
}

/**
 * Get request parameters. Will filter out any unsupported parameters.
 *
 * @param {Object} options Provided input options from calling method.
 * @param {Object} [defaults={}] Default options for the parameters.
 * @param {Object} [translationMaps={}] Mapping objects to translate
 *     query parameters against.
 * @returns {Object}
 */
export default function getParams(options) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var translationMaps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var params = _objectSpread(_objectSpread({}, defaults), options);
  if (options.filters) {
    params.filters = translateObject(translationMaps.filterColumnMap, options.filters);
  }
  if (typeof options.isPreview !== 'undefined') {
    delete params.isPreview;
    params.is_preview = options.isPreview;
  }
  if (options.page) {
    params.page = options.page;
  }
  if (options.perPage) {
    delete params.perPage;
    params.per_page = options.perPage;
  }
  if (options.sortOrder) {
    delete params.sortOrder;
    params.sort = getSortOrder(options.sortOrder, translationMaps.sortColumnMap);
  }
  return params;
}